import React from 'react';
import { ENROLLMENT_STATUSES } from 'src/pages/enrollments/constants';
import EnrollmentWorkqueue from 'src/pages/enrollments/pages/EnrollmentWorkqueue';

const CanceledEnrollments = () => (
  <EnrollmentWorkqueue enrollmentStatus={ENROLLMENT_STATUSES.canceled} />
);

export default CanceledEnrollments;
